import React from "react"
import Loading from "../../loading"
import HearingInstrumentsTable from "./hearingInstrumentsTable"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import Jumbotron from 'react-bootstrap/Jumbotron'

const TableContent = ({ 
  hearingInstruments = [], 
  isLoading, 
  sort = "", 
  setSorting = () => { },
  setPageNumber = () => { },
  pageNumber = 1,
  isLastPage = false
}) => {
  if (isLoading) {
    return <Loading isLoading={true} />    
  }
  if (!hearingInstruments ||  hearingInstruments.length === 0) {
    return <div className="container-fluid">
        <div className="row justify-content-center mt-5">
          <Jumbotron className="col-auto text-center px-5 py-4 mx-auto">
            <h4>No Hearing Instruments found</h4>
            <p>Please adjust your search or filter criteria</p>
          </Jumbotron>
        </div>
      </div>
  } 

  return (
    <div>
      <HearingInstrumentsTable
        hearingInstruments={hearingInstruments}
        sort={sort}
        setSorting={setSorting}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0.5rem 1rem",
        }}
      >
        <Button
          variant="success"
          onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
          disabled={pageNumber === 1 || isLoading}
        >
          Prev
        </Button>

        <span style={{ margin: "0 10px" }}>Page {pageNumber}</span>

        <Button
          variant="success"
          onClick={() => setPageNumber((p) => p + 1)}
          disabled={isLastPage || isLoading}
        >
          Next
        </Button>
      </div>
    </div>
  )
}

TableContent.propTypes = {
  hearingInstruments: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  sort: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  isLastPage: PropTypes.bool.isRequired,
}

export default TableContent
